import clsx from 'clsx';
import React, { FC } from 'react';
import styles from './TableTitle.module.scss';

export interface Props {
  title: React.ReactNode;
  count?: number;
  className?: string;
}

export const TableTitle: FC<Props> = (props) => {
  return (
    <div
      className={clsx(styles.titleContainer, props.className)}
      data-test-id="tableTitle"
    >
      <span className={styles.title}>{props.title}</span>
      <span className={styles.numberOfPatients}>{props.count}</span>
    </div>
  );
};
